import React from 'react';

import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';

export const N = React.memo((pz: ht.lblCz) => {

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.lblAbtz[_abtType] ? ica.lblAbtz[_abtType]() : {};

//console.log('LblC 15: ' + _abtType);
//console.log('LblC 16: ' + JSON.stringify(_abtz));
  return (
    cr.c(BoxC.N, {
      key: 'Fld.root',
      boxStlz: {
        ... _abtz?.boxStlz,
        ... pz.boxStlz,
      },
      oClds: [

        (pz.lblCz) ?
        cr.c(TextC.N, {
          key: -10,
          ... pz.lblCz,
          boxStlz: {
            ... _abtz?.lblCz?.boxStlz,
            ... pz.lblCz?.boxStlz,
          },
          textz: {
            ... pz.lblCz?.textz,
            stlz: {
              ... _abtz?.lblCz?.textz?.stlz,
              ... pz.lblCz?.textz?.stlz,
            }
          },
        })
        : null,

        (pz.cttCz) ?
        cr.c(BoxC.N, { // main
          key: -20,
          ... pz.cttCz,
          boxStlz: {
            ... _abtz?.cttCz?.boxStlz,
            ... pz.cttCz?.boxStlz,
          },
        })
        : null,

        (pz.omtCz) ?
        cr.c(TextC.N, { // main
          key: -30,
          ... pz.omtCz,
          boxStlz: {
            ... _abtz?.omtCz?.boxStlz,
            ... pz.omtCz?.boxStlz,
          },
          textz: {
            ... _abtz?.omtCz?.textz,
            ... pz.omtCz?.textz,
            stlz: {
              ... _abtz?.omtCz?.textz?.stlz,
              ... pz.omtCz?.textz?.stlz,
            }
          },
        })
        : null,

      ]
    })
  );
});
